import {MetricDataTree} from "classes/MetricDataTree"

export const useHasChartData = (parsedData: MetricDataTree[]) => parsedData && parsedData.length > 0 && !parsedData[0].isEmpty()